import { FormControl, Grid, TextField } from "@mui/material";
import { Controller, FieldError } from "react-hook-form";

import { gridSize } from "@/shared/constants";

type IdentificacionTextFieldProps = {
  label: string;
  error: FieldError | undefined;
  helperText: React.ReactNode;
  disabled?: boolean;
  shrink?: boolean;
  required?: boolean;

  type?: React.HTMLInputTypeAttribute;

  size?: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
  };

  onFetchCedulaRucInfo?: (value: any) => void;
  control: any;
  name: string;
  defaultValue?: string | number;
  selectedDocumentType: string;
};

const IdentificacionTextField: React.FC<IdentificacionTextFieldProps> = ({
  label,
  error,
  helperText,
  required = true,
  disabled = false,
  shrink = false,
  size = gridSize,
  type = "text",
  onFetchCedulaRucInfo,
  control,
  name,
  defaultValue,
  selectedDocumentType,
}) => {
  return (
    <Grid item {...size}>
      <FormControl fullWidth variant="outlined">
        <Controller
          control={control}
          name={name}
          defaultValue={defaultValue}
          disabled={disabled}
          render={({ field }) => {
            const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
              const isNumber = /^\d*$/.test(event.target.value);

              if (isNumber) {
                const isCedula =
                  selectedDocumentType === "CEDULA" ||
                  selectedDocumentType === "CÉDULA";
                const isRuc = selectedDocumentType === "RUC";
                let maxLength = 0;
                if (isCedula) {
                  maxLength = 10;
                } else if (isRuc) {
                  maxLength = 13;
                }

                let currentValue = event.target.value;

                if (currentValue.length <= maxLength) {
                  field.onChange(currentValue);

                  // Fetch data from the appropriate API if input reaches max length
                  if (
                    currentValue.length === maxLength &&
                    onFetchCedulaRucInfo
                  ) {
                    onFetchCedulaRucInfo(currentValue);
                  } else {
                    onFetchCedulaRucInfo && onFetchCedulaRucInfo("");
                  }
                }
              }
            };

            return (
              <TextField
                fullWidth
                variant="outlined"
                label={label}
                disabled={disabled}
                InputLabelProps={{ ...(shrink && { shrink: true }) }}
                {...field}
                error={!!error}
                helperText={helperText}
                type={type}
                required={required}
                onChange={onChange}
              />
            );
          }}
        ></Controller>
      </FormControl>
    </Grid>
  );
};

export default IdentificacionTextField;
